import { render, staticRenderFns } from "./ImportReviewsModal.vue?vue&type=template&id=3657ac8c&"
import script from "./ImportReviewsModal.vue?vue&type=script&lang=js&"
export * from "./ImportReviewsModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportReviewsModal.vue?vue&type=style&index=0&id=3657ac8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports